import { render, staticRenderFns } from "./Mba.vue?vue&type=template&id=73840e8b&"
import script from "./Mba.vue?vue&type=script&lang=js&"
export * from "./Mba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports